module.exports = __webpack_public_path__ + "static/media/battle.cbcdc8e1.png";